<template>
  <!-- Shown at the top of each guide page's sample-files section: a real page of the
       sample roadbook, what it contains (figures from the roadbook's own cover page),
       and how to open it in Rally Navigator. Clicks on the files are counted by the
       page's sample_download tracking (data-sample-source says where they came from). -->
  <div
    class="flex flex-col md:flex-row gap-6 md:gap-10 items-center md:items-start bg-[#1a1a1a] border border-[#333333] rounded-xl p-4 md:p-6 my-2"
  >
    <a
      :href="pdfHref"
      target="_blank"
      rel="noopener"
      data-sample-source="preview"
      class="shrink-0 block w-[220px] md:w-[260px] hover:opacity-90"
      :aria-label="`Open the ${name} sample roadbook PDF`"
    >
      <picture class="contents">
        <source :srcset="`/images/samples/${image}.webp`" type="image/webp" />
        <img
          :src="`/images/samples/${image}.png`"
          :width="imageWidth"
          :height="imageHeight"
          loading="lazy"
          decoding="async"
          :alt="`A page from the ${name} sample roadbook made in Rally Navigator, with distances, tulip diagrams and navigation icons`"
          class="w-full h-auto rounded-md border-4 border-white"
        />
      </picture>
      <span
        class="block text-center font-arial text-[13px] text-[#A9A9A9] mt-2 underline"
        >View the full PDF</span
      >
    </a>

    <div class="flex flex-col gap-3 font-arial text-left">
      <h3 class="font-russo text-white text-[20px] md:text-[24px]">
        See How a Real {{ name }} Roadbook Is Built
      </h3>
      <p class="text-white text-[15px] md:text-[17px] font-bold">
        {{ stats }}
      </p>
      <p class="text-[#A9A9A9] text-[15px] md:text-[17px]">
        {{ description }}
      </p>

      <ol
        class="list-decimal pl-6 flex flex-col gap-2 text-[#DDDDDD] text-[15px] md:text-[17px] mt-1"
      >
        <li>
          <router-link
            to="/download"
            class="text-[#FF0000] font-bold hover:underline"
            >Download Rally Navigator</router-link
          >
          and start your free 7-day trial.
        </li>
        <li>
          <a
            :href="rn2Href"
            :download="rn2Download"
            data-sample-source="cta"
            class="text-[#FF0000] font-bold hover:underline"
            >Download the sample roadbook (.rn2)</a
          >
        </li>
        <li>
          Double-click it, or use
          <span class="text-white">File &rarr; Open RN File&hellip;</span> in
          Rally Navigator &mdash; then explore every row, tulip and icon to see
          how it was made.
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SampleRoadbookIntro',
  props: {
    name: { type: String, required: true }, // e.g. "Cross Country"
    stats: { type: String, required: true }, // from the roadbook's cover page
    description: { type: String, required: true },
    image: { type: String, required: true }, // basename in /images/samples
    imageWidth: { type: Number, required: true },
    imageHeight: { type: Number, required: true },
    pdfHref: { type: String, required: true },
    rn2Href: { type: String, required: true },
  },
  computed: {
    rn2Download() {
      return decodeURIComponent(this.rn2Href.split('/').pop());
    },
  },
};
</script>
